import { lazy, Suspense } from 'react'
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom'
import AccessibleNavigationAnnouncer from './components/AccessibleNavigationAnnouncer'
import { AuthProvider } from './context/AuthContext'
import PrivateRoute from './components/PrivateRoute'
import {
  BreadcrumbsProvider,
  BreadcrumbsConsumer,
  withBreadcrumb,
  Crumb,
} from './context/HeaderContext'
import ThemedSuspense from './components/ThemedSuspense'
import ErrorBoundary from './components/ErrorBoundary'

const Layout = lazy(() => import('./containers/Layout'))
const Login = lazy(() => import('./pages/Login/Login'))
const Logout = lazy(() => import('./pages/Logout'))
const ResetPassword = lazy(() => import('./pages/Login/ResetPassword'))
const ResetPasswordMain = lazy(() => import('./pages/Login/ResetPasswordMain'))

function App() {
  return (
    <ErrorBoundary>
      <BreadcrumbsProvider>
        <Router>
          <AccessibleNavigationAnnouncer />
          <AuthProvider defaultRequireAuth={true}>
            <Suspense fallback={<ThemedSuspense />}>
              <Switch>
                <Route path="/logout" component={Logout} />
                <Redirect exact from="/" to="/login" />
                <Route path="/login" component={Login} />
                <Route path="/reset-password/:token" component={ResetPassword} />
                <Route path="/reset-password" component={ResetPasswordMain} />
                <PrivateRoute path="/app" component={Layout} />
              </Switch>
            </Suspense>
          </AuthProvider>
        </Router>
      </BreadcrumbsProvider>
    </ErrorBoundary>
  )
}

export default App
